export default {"src":"/_next/static/media/footer-bg.fad5e337.svg","height":1466,"width":1920};